module.exports = "/_next/static/resources/art-b08e4a0fa95cc44c78488abd6e32c00e.webp";